<div class="tab-modal">
  <div class="tab-modal__backdrop" (click)="closeModal()"></div>
  <div class="tab-modal-container">
    <div class="tab-modal-container__content" *ngIf="tab && !tabIsClosed">
      <svg class="tab-modal-container__close-button" aria-label="Close" (click)="closeModal()">
        <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
      </svg>
      <div class="tab-modal-container__content-title">Adding to {{paymentStore.customer?.givenName}}’s tab</div>
      <div class="tab-modal-container__content-text">This is an open tab. If you would like to close this tab to start a new one, please
        <a class="tab-modal-container__content-text-link" (click)="closeTabPageLink()">click here</a>.
      </div>
    </div>

      <div class="tab-modal-container__closed" *ngIf="tab && tabIsClosed">
        <div class="tab-modal-container__closed-title">This tab is closed</div>
        <div class="tab-modal-container__closed-text">This is a closed tab. If you would like to start a new tab, please click
          <span class="tab-modal-container__closed-text-colored">Back to menu</span>
        </div>
      </div>

      <div class="tab-modal-container__closed" *ngIf="cartStore.tabClosedSuccessful">
        <div class="tab-modal-container__closed-title">Thanks for ordering!</div>
        <div class="tab-modal-container__closed-text">You have successfully closed your tab.
        </div>
      </div>
    <div class="tab-modal-container__footer">
      <button class="tab-modal-container__footer-button"
              (click)="closeModal()">{{cartStore.tabClosedSuccessful || tabIsClosed ? 'Back to menu' : 'Start ordering'}}</button>
    </div>
  </div>
</div>
